import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import renderReliability from "@/components/tippy/Tippy";
import { checkSupression } from "@/utils/index";
import { AppContext, ContextType } from "@/shared/context";

const EmployeeSiteBlock = (props) => {
  const { t } = useTranslation();
  const { isUnitedStates, isEuBd } = useContext(AppContext) as ContextType;

  const reliabilityTag = (type) => {
    return t(`companyProfile.overview.${type.toLowerCase()}`)
  }

  const toolTipContent = (type) => {
    if(isUnitedStates) {
      return  t(`companyProfile.overview.reliabilityDefinitionEmployees${type}`); 
    } else {
      if (type === "Actual") {
        if (["de", "ch", "at"].includes(props.countryCode)) return t("companyProfile.overview.reliabilityDefinitionSalesEstimated")
        if (props.countryCode === "hu") return t("companyProfile.overview.reliabilityDefinitionEmployeeActual")
        if (props.countryCode === "pl") return t("companyProfile.overview.reliabilityDefinitionSalesEstimated")
  
          return t("companyProfile.overview.reliabilityDefinitionSalesActual")
      }
  
      if (type === "Modelled" && props.countryCode === 'hu') {
        return t("companyProfile.overview.reliabilityDefinitionEmployeeActual")
      }
  
      if (type === "Modelled" && ['de','at','ch','pl'].includes(props.countryCode)) {
        return t("companyProfile.overview.reliabilityDefinitionSalesEstimated")
      }
  
      return t(`companyProfile.overview.reliabilityDefinitionSales${type}`)
    }
  }

  return (
    <div className="row mt-0 margin-between-rows flex-nowrap">
      <div className="col-md-1 company-profile-overview-icon-employees"></div>
      <div className="col-md-11">
      {props.employeesThisSiteValue && (
        <>
        <span className="company_data_point" name="employees_this_site" id="company_employees_site">
          <label className="overviewEmployee">{t("companyProfile.overview.employee_this_site_label")}: 
          </label>
          <span data-tracking-name={t("companyProfile.overview.employee_this_site_label")}>
            {checkSupression(props.employeesThisSiteValue)}
          </span>
          {props.employeesThisSiteReliability && (
            renderReliability(
              toolTipContent(props.employeesThisSiteReliability),
              reliabilityTag(props.employeesThisSiteReliability)
            )
          )}
        </span>
        <br />
        </>
        )}

        {/* All sites */}
        {props.employeesConsolidatedValue && (
          <span className="company_data_point d-flex align-items-center" name="employees_all_site">
            <label className="overviewEmployee">{t("companyProfile.overview.employee_all_sites_label")}: 
            <span data-tracking-name={t("companyProfile.overview.employee_all_sites_label")}>
              {checkSupression(props.employeesConsolidatedValue)}
            </span>
            </label>

            {isUnitedStates && <br />}
            {props.employeesConsolidatedReliability && (
              renderReliability(
                toolTipContent(props.employeesConsolidatedReliability),
                reliabilityTag(props.employeesConsolidatedReliability)
              )
            )}
          </span>
        )}
      </div>
    </div>
  )
}

export default EmployeeSiteBlock;